export default __webpack_public_path__ + "static/andy-video-4d1187a12d08f9afa2a1c2f355b7105d.mp4";